import API from "./axios";

/**
 * Stitching Entry — issue and inward in one entry, a day's sheet: rows of
 * employee, barcode, operation and qty. Billed employee-wise from Job Work
 * Entry.
 */
const stitchingEntryApi = {
  paged:   (params = {}) => API.get("/stitching-entries/paged", { params }),
  getById: (id)          => API.get(`/stitching-entries/${id}`),
  /** body: { locationId, entryDate, notes, allowExtra, items: [{ employeeId, saleOrderItemId, operationId, qty }] } */
  create:  (body)        => API.post("/stitching-entries", body),
  update:  (id, body)    => API.put(`/stitching-entries/${id}`, body),
  cancel:  (id)          => API.patch(`/stitching-entries/${id}/cancel`),
  exportExcel: (params = {}) => API.get("/stitching-entries/export/excel", { params, responseType: "blob" }),

  // Stitching report — date, employee, barcode, operation, qty, rate / pc, amount.
  /** params: { from, to, employeeId, operationId, locationId, q } → { rows, totalQty, totalAmount, truncated } */
  report:      (params = {}) => API.get("/stitching-entries/report", { params }),
  reportExcel: (params = {}) => API.get("/stitching-entries/report/excel", { params, responseType: "blob" }),
  reportPdf:   (params = {}) => API.get("/stitching-entries/report/pdf", { params, responseType: "blob" }),
  /** Active stitching operations — the report's filter. */
  operations:  ()            => API.get("/stitching-entries/operations"),

  // Pick lists — served under STITCHING_ENTRY, so no rights on the masters are needed.
  // With a locationId they offer only that location's employees, the sale order
  // lines it has a share of, and what is left of its share.
  employees: (locationId) => API.get("/stitching-entries/employees", { params: { locationId: locationId || undefined } }),
  /** Sale order lines by production barcode, barcode, product or SO number. */
  soItems:   (q, locationId) => API.get("/stitching-entries/so-items", { params: { q, locationId: locationId || undefined } }),
  /** Operations for one sale order line, with rate, done and left. */
  soItemOperations: (soItemId, excludeEntryId, locationId) =>
    API.get(`/stitching-entries/so-items/${soItemId}/operations`, {
      params: { excludeEntryId: excludeEntryId || undefined, locationId: locationId || undefined },
    }),
};

export default stitchingEntryApi;
